// extracted by mini-css-extract-plugin
export var active = "agenda-module--active--10aee";
export var agendaBlock = "agenda-module--agendaBlock--b306e";
export var dropDownTitle = "agenda-module--dropDownTitle--19dea";